<template>
	<div id="app">
		<Header v-if="!this.$route.meta.single" />
		<div class="router-view">
			<router-view></router-view>
		</div>
		<Footer v-if="!this.$route.meta.single" />
	</div>
</template>

<script>
import './base.css'
import Header from './components/header.vue'
import Footer from './components/footer.vue'
export default {
	name: 'App',
	components: {
		Header,
		Footer
	}
}
</script>



// WEBPACK FOOTER //
// src/App.vue